// Button Block - Clickable button with link
class ButtonBlock {
  static get toolbox() {
    return {
      title: 'Button',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="8" rx="2" ry="2"></rect></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      text: data.text || 'Click me',
      link: data.link || data.url || '',
      style: data.style || 'primary',
      newTab: data.newTab !== undefined ? data.newTab : true
    };
    this.readOnly = readOnly;
    this.wrapper = null;
    this.styles = config?.styles || ['primary', 'secondary', 'outline', 'ghost'];
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _getButtonClasses(style) {
    const classes = {
      primary: 'bg-blue-600 hover:bg-blue-700 text-white',
      secondary: 'bg-slate-600 hover:bg-slate-700 text-white',
      outline: 'border-2 border-blue-600 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20',
      ghost: 'text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20'
    };
    return classes[style] || classes.primary;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="flex items-center gap-4" data-testid="button-block">
        ${this.readOnly ? `
          <a href="${this.data.link || '#'}" ${this.data.newTab ? 'target="_blank" rel="noopener"' : ''} class="inline-flex items-center px-4 py-2 rounded-lg font-medium transition-colors ${this._getButtonClasses(this.data.style)}">
            ${this.data.text}
          </a>
        ` : `
          <div class="flex items-center gap-2 flex-wrap">
            <select class="style-select text-xs px-2 py-1 rounded border bg-white dark:bg-slate-800">
              ${this.styles.map(s => `<option value="${s}" ${this.data.style === s ? 'selected' : ''}>${s}</option>`).join('')}
            </select>
            <input type="text" class="text-input px-3 py-1 rounded border text-sm w-32" placeholder="Button text" value="${this.data.text}" />
            <input type="text" class="url-input px-3 py-1 rounded border text-sm w-48" placeholder="https://example.com" value="${this.data.link}" />
            <label class="flex items-center gap-1 text-xs text-slate-500">
              <input type="checkbox" class="newtab-check" ${this.data.newTab ? 'checked' : ''} />
              New tab
            </label>
          </div>
          <span class="button-preview inline-flex items-center px-4 py-2 rounded-lg font-medium ${this._getButtonClasses(this.data.style)}">${this.data.text}</span>
        `}
      </div>
    `;

    if (!this.readOnly) {
      const styleSelect = this.wrapper.querySelector('.style-select');
      const textInput = this.wrapper.querySelector('.text-input');
      const urlInput = this.wrapper.querySelector('.url-input');
      const newTabCheck = this.wrapper.querySelector('.newtab-check');
      const buttonPreview = this.wrapper.querySelector('.button-preview');

      // Style change - needs re-render for button color change
      styleSelect?.addEventListener('change', (e) => {
        this.data.style = e.target.value;
        this._render();
      });

      // Text input - update data and preview WITHOUT re-rendering
      textInput?.addEventListener('input', (e) => {
        this.data.text = e.target.value;
        if (buttonPreview) {
          buttonPreview.textContent = e.target.value || 'Click me';
        }
      });

      // URL input - just update data, no re-render needed
      urlInput?.addEventListener('input', (e) => {
        this.data.link = e.target.value;
      });

      // New tab checkbox - just update data
      newTabCheck?.addEventListener('change', (e) => {
        this.data.newTab = e.target.checked;
      });
    }
  }

  save() {
    return {
      text: this.data.text,
      link: this.data.link,
      style: this.data.style,
      newTab: this.data.newTab
    };
  }
}

export default ButtonBlock;
